import { autoinject, bindable, bindingMode, customElement, observable } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
@autoinject
export class TextAreaBaseCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) rows: number = 5;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) configJson: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) isHtmlText: boolean = false;

    protected element: any = null;

    constructor(element: Element) {
        super();
        this.element = element;
    }

    valueChanged(newValue, oldValue) {
        if (newValue != oldValue) {
            if (ObjectHelper.IsNotNullAndUndefined(this.onChange) && !this.forceChange) {
                this.onChange();
            }
        }
    }

    public OpenTextareaDialog() {
        ($(this.element) as any).find('[role="dialog"][dialog-type="textarea"]').modal('show');
    }

    public CloseTextareaModal() {
        ($(this.element) as any).find('[role="dialog"][dialog-type="textarea"]').modal('hide');
    }
}